// Ποσό σε ευρώ όπως το γράφει ο Έλληνας: «2,60 €», «1.234,50 €». Μόνο για εμφάνιση —
// δεν στρογγυλοποιεί χρήματα που στέλνονται πουθενά.
const NUMBER = new Intl.NumberFormat('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatEuro = (amount: number): string =>
  `${NUMBER.format(Number.isFinite(amount) ? amount : 0)} €`;
